import styles from "./index.module.less";
import WebsiteIcon from "../../../assets/pictures/www.png";
import LinkedInIcon from "../../../assets/pictures/linkedin.png";
import FacebookIcon from "../../../assets/pictures/facebook.png";
import YouTubeIcon from "../../../assets/pictures/youtube.png";
import LocationIcon from "../../../assets/pictures/map.png";

const SocialMediaLinks = () => {
  return (
    <div className={styles["social-link-container"]}>
      <a href="https://www.wipropari.com/" target="_blank" rel="noopener noreferrer" aria-label="Website">
        <img src={WebsiteIcon} alt="Website" className={styles["icon-size"]} />
      </a>
      <a href="https://www.linkedin.com/company/wipropari" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <img src={LinkedInIcon} alt="Website" className={styles["icon-size"]} />
      </a>
      <a href="https://www.facebook.com/WiproPARI" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
        <img src={FacebookIcon} alt="Website" className={styles["icon-size"]} />
      </a>
      <a href="https://www.youtube.com/c/WiproPARI" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
        <img src={YouTubeIcon} alt="Website" className={styles["icon-size"]} />
      </a>
      <a href="https://maps.app.goo.gl/sjVZyHmZiyqmG1DY7" target="_blank" rel="noopener noreferrer" aria-label="Location">
        <img src={LocationIcon} alt="Website" className={styles["icon-size"]} />
      </a>
    </div>
  );
};

export default SocialMediaLinks;
